<template lang="html">
  <main>
    <div class="login-image">
      <img
        src="@/assets/images/login-image.png"
        srcset="@/assets/images/login-image.png 1x, @/assets/images/login-image@2x.png 2x"
        alt="logo"
        draggable="false"
      />
    </div>
    <div class="view">
      <router-view/>
    </div>

    <transition name="modal-fade-scale">
      <Prompt v-if="$store.getters['modals/prompt/isOpened']"/>
    </transition>

  </main>
</template>

<script>
import Prompt from '@/components/common/modals/Prompt'


export default {
  components: {
    Prompt,
  }
}
</script>

<style lang="scss" scoped>

::v-deep {
  .form-wrap {
    flex-basis:100%;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
  }
}


main {
  display: flex;
  flex-direction: row;
  .login-image {
    flex-basis: 40%;
    height: 100%;
    max-width: 300px;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }
  .auth-view {
    display: flex;
    flex-direction: row;
    height: 100%;
    flex-grow: 2;
    background-color: #fff;
  }
  .header {
    text-align: center;
    margin: 20px 0;
  }
  .view {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  .form {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    > * {
      margin: 10px 0;
    }
  }
  @media (max-width:1100px) {
    &#content {
      display: block;
      .login-image {
        display: none;
      }
      &::v-deep {
        .login-form {
          padding: 0 12px;
          .logo {
            width: 100%;
          }
          form {
            width: 100%;
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: flex-start;
            > * {
              flex-basis: 100%;
              width: 100%;
            }
            .checkboxes {
              flex-direction: column;
              .forgot-password {
                text-align: right;
              }
            }

          }
          .buttons {
            flex-direction: column;
            width: 100%;
            flex-wrap: nowrap;
            .a-btn {
              margin-bottom: 12px;
              margin-top: 0;
              flex-basis: 100%;
            }
          }
        }
      }
    }
  }
}

@media(max-width: 768px) {
  main {
    .auth-view::v-deep {
      .form-wrap {
        .logo {
          width: 280px;;
        }
      }
    }
  }
}

</style>
